import { useParams, NavLink, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

const AdminMenu = () => {
    const location = useLocation();
    const path = location.pathname;
    const [isMainOpen, setIsMainOpen] = useState(false);
    const [isAlipurduarOpen, setIsAlipurduarOpen] = useState(false);
    const [isBolpurOpen, setIsBolpurOpen] = useState(false);
    const [isCoochbeharOpen, setIsCoochbeharOpen] = useState(false);
    const [isDurgapurOpen, setIsDurgapurOpen] = useState(false);
    const [isFalakataOpen, setIsFalakataOpen] = useState(false);
    const [isGangarampurOpen, setIsGangarampurOpen] = useState(false);
    const [isHooghlyOpen, setIsHooghlyOpen] = useState(false);
    const [isJalpaiguriOpen, setIsJalpaiguriOpen] = useState(false);
    const [isKolaghatOpen, setIsKolaghatOpen] = useState(false);
    const [isKrishnanagarOpen, setIsKrishnanagarOpen] = useState(false);
    const [isMidnaporeOpen, setIsMidnaporeOpen] = useState(false);
    const [isNabadwipOpen, setIsNabadwipOpen] = useState(false);
    const [isRaiganjOpen, setIsRaiganjOpen] = useState(false);
    const [isRaniganjOpen, setIsRaniganjOpen] = useState(false);
    const [isSiliguriOpen, setIsSiliguriOpen] = useState(false);


    const [isHomeOpen, setIsHomeOpen] = useState(false);
    const [isAboutOpen, setIsAboutOpen] = useState(false);
    const [isAcademicsOpen, setIsAcademicsOpen] = useState(false);
    const [isAdmissionOpen, setIsAdmissionOpen] = useState(false);
    const [isLifeAtTIGPSOpen, setIsLifeAtTIGPSOpen] = useState(false);
    const [isGeneralSettingsOpen, setIsGeneralSettingsOpen] = useState(false);
    const [isSchoolListOpen, setIsSchoolListOpen] = useState(false);
    const [isFileUploadsOpen, setIsFileUploadsOpen] = useState(false);

    useEffect(() => {
        const isHomePage  = path.startsWith("/admin/home-page");
        const isAboutPage = path.startsWith("/admin/about-page/");
        const isAcademicPage = path.startsWith("/admin/academic-page/");
        const isAdmissionPage = path.startsWith("/admin/admission-page/");
        const isLifePage = path.startsWith("/admin/life-at-tigps-page/");
        const isGeneralSettingsPage = path.startsWith("/admin/general-settings/");
        const isFileUploadsOpen = path.startsWith("/admin/file-upload/");
        const isSchoolListOpen = path.startsWith("/admin/school-list/");

        // Main webiste
        setIsMainOpen(
            path.includes("/tigps-main") &&
            (isHomePage ||isAboutPage || isAcademicPage || isLifePage || isAdmissionPage || isGeneralSettingsPage || isSchoolListOpen)
        );
        // Alipurduar
        setIsAlipurduarOpen(
            path.includes("/alipurduar") &&
            (isHomePage ||isAboutPage || isAcademicPage || isLifePage || isAdmissionPage || isGeneralSettingsPage || isFileUploadsOpen)
        );
        // Bolpur
        setIsBolpurOpen(
            path.includes("/bolpur") &&
            (isHomePage ||isAboutPage || isAcademicPage || isLifePage || isAdmissionPage || isGeneralSettingsPage || isFileUploadsOpen)
        );
        // Coochbehar
        setIsCoochbeharOpen(
            path.includes("/coochbehar") &&
            (isHomePage ||isAboutPage || isAcademicPage || isLifePage || isAdmissionPage || isGeneralSettingsPage || isFileUploadsOpen)
        );
        // Durgapur
        setIsDurgapurOpen(
            path.includes("/durgapur") &&
            (isHomePage ||isAboutPage || isAcademicPage || isLifePage || isAdmissionPage || isGeneralSettingsPage || isFileUploadsOpen)
        );
        // Falakata
        setIsFalakataOpen(
            path.includes("/falakata") &&
            (isHomePage ||isAboutPage || isAcademicPage || isLifePage || isAdmissionPage || isGeneralSettingsPage || isFileUploadsOpen)
        );
        // Gangarampur
        setIsGangarampurOpen(
            path.includes("/gangarampur") &&
            (isHomePage ||isAboutPage || isAcademicPage || isLifePage || isAdmissionPage || isGeneralSettingsPage || isFileUploadsOpen)
        );
        // Hooghly
        setIsHooghlyOpen(
            path.includes("/hooghly") &&
            (isHomePage ||isAboutPage || isAcademicPage || isLifePage || isAdmissionPage || isGeneralSettingsPage || isFileUploadsOpen)
        );
        // Jalpaiguri
        setIsJalpaiguriOpen(
            path.includes("/jalpaiguri") &&
            (isHomePage ||isAboutPage || isAcademicPage || isLifePage || isAdmissionPage || isGeneralSettingsPage || isFileUploadsOpen)
        );
        // Kolaghat
        setIsKolaghatOpen(
            path.includes("/kolaghat") &&
            (isHomePage ||isAboutPage || isAcademicPage || isLifePage || isAdmissionPage || isGeneralSettingsPage || isFileUploadsOpen)
        );
        // Krishnanagar
        setIsKrishnanagarOpen(
            path.includes("/krishnanagar") &&
            (isHomePage ||isAboutPage || isAcademicPage || isLifePage || isAdmissionPage || isGeneralSettingsPage || isFileUploadsOpen)
        );
        // Midnapore
        setIsMidnaporeOpen(
            path.includes("/midnapore") &&
            (isHomePage ||isAboutPage || isAcademicPage || isLifePage || isAdmissionPage || isGeneralSettingsPage || isFileUploadsOpen)
        );
        // Nabadwip
        setIsNabadwipOpen(
            path.includes("/nabadwip") &&
            (isHomePage ||isAboutPage || isAcademicPage || isLifePage || isAdmissionPage || isGeneralSettingsPage || isFileUploadsOpen)
        );
        // Raiganj
        setIsRaiganjOpen(
            path.includes("/raiganj") &&
            (isHomePage ||isAboutPage || isAcademicPage || isLifePage || isAdmissionPage || isGeneralSettingsPage || isFileUploadsOpen)
        );
        // Raniganj
        setIsRaniganjOpen(
            path.includes("/raniganj") &&
            (isHomePage ||isAboutPage || isAcademicPage || isLifePage || isAdmissionPage || isGeneralSettingsPage || isFileUploadsOpen)
        );
        // Siliguri
        setIsSiliguriOpen(
            path.includes("/siliguri") &&
            (isHomePage ||isAboutPage || isAcademicPage || isLifePage || isAdmissionPage || isGeneralSettingsPage || isFileUploadsOpen)
        );

        setIsHomeOpen(isHomePage);
        setIsAboutOpen(isAboutPage);
        setIsAcademicsOpen(isAcademicPage);
        setIsAdmissionOpen(isAdmissionPage);
        setIsLifeAtTIGPSOpen(isLifePage);
        setIsGeneralSettingsOpen(isGeneralSettingsPage);
        setIsFileUploadsOpen(isFileUploadsOpen);
        setIsSchoolListOpen(isSchoolListOpen);

    }, [path]);

    {/* ------------- Open School Menu ----------------*/}
    const toggleMain = (e) => {
        e.preventDefault();
        setIsMainOpen(prev => !prev);
    };

    const toggleAlipurduar = (e) => {
        e.preventDefault();
        setIsAlipurduarOpen(prev => !prev);
    };

    const toggleBolpur = (e) => {
        e.preventDefault();
        setIsBolpurOpen(prev => !prev);
    };

    const toggleCoochbehar = (e) => {
        e.preventDefault();
        setIsCoochbeharOpen(prev => !prev);
    };

    const toggleDurgapur = (e) => {
        e.preventDefault();
        setIsDurgapurOpen(prev => !prev);
    };

    const toggleFalakata = (e) => {
        e.preventDefault();
        setIsFalakataOpen(prev => !prev);
    };

    const toggleGangarampur = (e) => {
        e.preventDefault();
        setIsGangarampurOpen(prev => !prev);
    };

    const toggleHooghly = (e) => {
        e.preventDefault();
        setIsHooghlyOpen(prev => !prev);
    };

    const toggleJalpaiguri = (e) => {
        e.preventDefault();
        setIsJalpaiguriOpen(prev => !prev);
    };

    const toggleKolaghat = (e) => {
        e.preventDefault();
        setIsKolaghatOpen(prev => !prev);
    };

    const toggleKrishnanagar = (e) => {
        e.preventDefault();
        setIsKrishnanagarOpen(prev => !prev);
    };

    const toggleMidnapore = (e) => {
        e.preventDefault();
        setIsMidnaporeOpen(prev => !prev);
    };

    const toggleNabadwip = (e) => {
        e.preventDefault();
        setIsNabadwipOpen(prev => !prev);
    };

    const toggleRaiganj = (e) => {
        e.preventDefault();
        setIsRaiganjOpen(prev => !prev);
    };

    const toggleRaniganj = (e) => {
        e.preventDefault();
        setIsRaniganjOpen(prev => !prev);
    };

    const toggleSiliguri = (e) => {
        e.preventDefault();
        setIsSiliguriOpen(prev => !prev);
    };


    {/* ------------- Open Section ----------------*/}

    const toggleHome = (e) => {
        e.preventDefault();
        setIsHomeOpen(prev => !prev);
    };

    const toggleAbout = (e) => {
        e.preventDefault();
        setIsAboutOpen(prev => !prev);
    };

    const toggleAcademics = (e) => {
        e.preventDefault();
        setIsAcademicsOpen(prev => !prev);
    };

    const toggleAdmission = (e) => {
        e.preventDefault();
        setIsAdmissionOpen(prev => !prev);
    };

    const toggleLifeAtTIGPS = (e) => {
        e.preventDefault();
        setIsLifeAtTIGPSOpen(prev => !prev);
    };


    useEffect(() => {
        if (!path.includes("/tigps-main")) {
            setIsMainOpen(false);
        }
        if (!path.includes("/alipurduar")) {
            setIsAlipurduarOpen(false);
        }
        if (!path.includes("/bolpur")) {
            setIsBolpurOpen(false);
        }
        if (!path.includes("/coochbehar")) {
            setIsCoochbeharOpen(false);
        }
        if (!path.includes("/durgapur")) {
            setIsDurgapurOpen(false);
        }
        if (!path.includes("/falakata")) {
            setIsFalakataOpen(false);
        }
        if (!path.includes("/gangarampur")) {
            setIsGangarampurOpen(false);
        }
        if (!path.includes("/hooghly")) {
            setIsHooghlyOpen(false);
        }
        if (!path.includes("/jalpaiguri")) {
            setIsJalpaiguriOpen(false);
        }
        if (!path.includes("/kolaghat")) {
            setIsKolaghatOpen(false);
        }
        if (!path.includes("/krishnanagar")) {
            setIsKrishnanagarOpen(false);
        }
        if (!path.includes("/midnapore")) {
            setIsMidnaporeOpen(false);
        }
        if (!path.includes("/nabadwip")) {
            setIsNabadwipOpen(false);
        }
        if (!path.includes("/raiganj")) {
            setIsRaiganjOpen(false);
        }
        if (!path.includes("/raniganj")) {
            setIsRaniganjOpen(false);
        }
        if (!path.includes("/siliguri")) {
            setIsSiliguriOpen(false);
        }
    }, [path]);

    return (
        <aside className="main-sidebar sidebar-dark-primary elevation-4 position-fixed">
            {/* Brand Logo */}
            <NavLink to="/admin/dashboard" className="brand-link text-center">
                <span className="brand-text font-weight-light ml-2">TIGPS</span>
            </NavLink>

            {/* Sidebar */}
            <div className="sidebar">
                <nav className="mt-2">
                    <ul
                        className="nav nav-pills nav-sidebar flex-column"
                        role="menu"
                    >
                        {/* Dashboard */}
                        <li className="nav-item">
                            <NavLink
                                to="/admin/dashboard"
                                end
                                className={({ isActive }) =>
                                    `nav-link ${isActive ? "active" : ""}`
                                }
                            >
                                <i className="nav-icon fas fa-tachometer-alt" />
                                <p className="admin-menu-p">Dashboard</p>
                            </NavLink>
                        </li>
                        {/* -------------- TIGPS Main website ------------ */}
                        <li className={`nav-item school-block ${isMainOpen ? "menu-open" : ""}`}>
                            <a href="#" className={`nav-link ${isMainOpen ? "active" : ""}`} onClick={toggleMain}>
                                <i className="nav-icon fas fa-tachometer-alt" />
                                <p className="admin-menu-p">
                                    TIGPS - main
                                    <i className="right fas fa-angle-left" />
                                </p>
                            </a>
                            <ul className="nav nav-treeview under-school-block">
                                <li className={`nav-item ${isHomeOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isHomeOpen ? "active" : ""}`} onClick={toggleHome}>
                                        <i className="fas fa-home nav-icon" />
                                        <p className="admin-menu-p">
                                            Home page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Home about section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/home-about-section/tigps-main"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`}
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home about</p>
                                            </NavLink>
                                        </li>
                                        {/* Home mission vision */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/mission-vision-section/tigps-main"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home mission-vision</p>
                                            </NavLink>
                                        </li>
                                        {/* Home Achiver Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/achievers/tigps-main"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Achievers</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAboutOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAboutOpen ? "active" : ""}`} onClick={toggleAbout}>
                                        <i className="fas fa-building nav-icon" />
                                        <p className="admin-menu-p">
                                            About page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* About Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/about-section/tigps-main"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">About</p>
                                            </NavLink>
                                        </li>
                                        {/* Affiliations and Certifications */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/affiliations-certifications-section/tigps-main"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Affiliations and Certifications</p>
                                            </NavLink>
                                        </li>
                                        {/* Accolades & Awards */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/accolades-awards-section/tigps-main"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Accolades & Awards</p>
                                            </NavLink>
                                        </li>
                                        {/* Accolades & Awards */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/csr-section/tigps-main"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">CSR section</p>
                                            </NavLink>
                                        </li>
                                        {/* Accolades & Awards */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/mentorship-section/tigps-main"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mentorship</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAcademicsOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAcademicsOpen ? "active" : ""}`} onClick={toggleAcademics}>
                                        <i className="nav-icon fas fa-chalkboard-teacher" />
                                        <p className="admin-menu-p">Academics page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Pre primary program section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/academic-page/pre-primary-program-section/tigps-main"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Pre primary program</p>
                                            </NavLink>
                                        </li>
                                        {/* Primary program section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/academic-page/primary-program-section/tigps-main"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Primary program</p>
                                            </NavLink>
                                        </li>
                                        {/* Senior section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/academic-page/senior-section/tigps-main"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Senior section</p>
                                            </NavLink>
                                        </li>
                                        {/* Senior Secondary section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/academic-page/senior-secondary-section/tigps-main"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Senior secondary section</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAdmissionOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAdmissionOpen ? "active" : ""}`} onClick={toggleAdmission}>
                                        <i className="nav-icon fas fa-graduation-cap" />
                                        <p className="admin-menu-p">Admission page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Criteria section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/criteria-section/tigps-main"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Criteria </p>
                                            </NavLink>
                                        </li>
                                        {/* Admission Application Procedur eSection section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-application-procedure-section/tigps-main"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Procedure</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isLifeAtTIGPSOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isLifeAtTIGPSOpen ? "active" : ""}`} onClick={toggleLifeAtTIGPS}>
                                        <i className="nav-icon 	fas fa-school" />
                                        <p className="admin-menu-p">Life at TIGPS</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Pre primary program section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/life-at-tigps-section/tigps-main"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Beyond academics</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/gallery/tigps-main"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Gallery</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/news-clippings/tigps-main"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">News clippings</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/event-list/tigps-main"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Event list</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className="nav-item">
                                    <a href="/admin/general-settings/tigps-main" className={`nav-link ${isGeneralSettingsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">General settings</p>
                                    </a>
                                </li> 
                                <li className="nav-item">
                                    <a href="/admin/school-list/tigps-main" className={`nav-link ${isSchoolListOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">School list</p>
                                    </a>
                                </li> 
                            </ul>
                        </li>

                        {/* -------------- TIGPS Alipurduar ------------ */}
                        <li className={`nav-item school-block mt-2 ${isAlipurduarOpen ? "menu-open" : ""}`}>
                            <a href="#" className={`nav-link ${isAlipurduarOpen ? "active" : ""}`} onClick={toggleAlipurduar}>
                                <i className="nav-icon fas fa-tachometer-alt" />
                                <p className="admin-menu-p">
                                    TIGPS - Alipurduar
                                    <i className="right fas fa-angle-left" />
                                </p>
                            </a>
                            <ul className="nav nav-treeview under-school-block">
                                <li className={`nav-item ${isHomeOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isHomeOpen ? "active" : ""}`} onClick={toggleHome}>
                                        <i className="fas fa-home nav-icon" />
                                        <p className="admin-menu-p">
                                            Home page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Home about section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/home-about-section/alipurduar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`}
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home about</p>
                                            </NavLink>
                                        </li>
                                        {/* Achiver Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/achievers/alipurduar"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home achivers</p>
                                            </NavLink>
                                        </li>
                                        {/* WHY CHOOSE US Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/why-choose-us/alipurduar"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Why choose us</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAboutOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAboutOpen ? "active" : ""}`} onClick={toggleAbout}>
                                        <i className="fas fa-building nav-icon" />
                                        <p className="admin-menu-p">
                                            About page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* About Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/about-section/alipurduar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">About</p>
                                            </NavLink>
                                        </li>
                                        {/* Mission Vision */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/mission-vision-section/alipurduar"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mission-Vision</p>
                                            </NavLink>
                                        </li>
                                        {/* Affiliations and Certifications */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/affiliations-certifications-section/alipurduar"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Affiliations and Certifications</p>
                                            </NavLink>
                                        </li>
                                        {/* CSR Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/csr-section/alipurduar"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">CSR section</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAcademicsOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAcademicsOpen ? "active" : ""}`} onClick={toggleAcademics}>
                                        <i className="nav-icon fas fa-chalkboard-teacher" />
                                        <p className="admin-menu-p">Academics page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                       {/* Mandatory Disclosure */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/academic-page/mandatory-disclosure/alipurduar"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mandatory Disclosure</p>
                                            </NavLink>
                                        </li> 
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAdmissionOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAdmissionOpen ? "active" : ""}`} onClick={toggleAdmission}>
                                        <i className="nav-icon fas fa-graduation-cap" />
                                        <p className="admin-menu-p">Admission page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Admission Overview */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-overview/alipurduar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Overview </p>
                                            </NavLink>
                                        </li>
                                        {/* Admission Application Procedur Section section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-application-procedure-section/alipurduar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Procedure</p>
                                            </NavLink>
                                        </li>
                                        {/* Criteria section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/criteria-section/alipurduar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Criteria </p>
                                            </NavLink>
                                        </li>
                                        
                                        {/* School uniform */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/school-uniform/alipurduar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">School uniform</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isLifeAtTIGPSOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isLifeAtTIGPSOpen ? "active" : ""}`} onClick={toggleLifeAtTIGPS}>
                                        <i className="nav-icon 	fas fa-school" />
                                        <p className="admin-menu-p">Life at TIGPS</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Pre primary program section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/life-at-tigps-section/alipurduar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Beyond academics</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/gallery/alipurduar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Gallery</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/videos/alipurduar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Videos</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/news-clippings/alipurduar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">News clippings</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/event-list/alipurduar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Event list</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/newsletter/alipurduar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Newsletter</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/techno-echo/alipurduar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Techno Echo</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/prospectus/alipurduar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Prospectus</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className="nav-item">
                                    <a href="/admin/general-settings/alipurduar" className={`nav-link ${isGeneralSettingsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">General settings</p>
                                    </a>
                                </li> 
                                <li className="nav-item">
                                    <a href="/admin/file-upload/alipurduar" className={`nav-link ${isFileUploadsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">File upload</p>
                                    </a>
                                </li> 
                            </ul>
                        </li>

                        {/* -------------- TIGPS Bolpur ------------ */}
                        <li className={`nav-item school-block mt-2 ${isBolpurOpen ? "menu-open" : ""}`}>
                            <a href="#" className={`nav-link ${isBolpurOpen ? "active" : ""}`} onClick={toggleBolpur}>
                                <i className="nav-icon fas fa-tachometer-alt" />
                                <p className="admin-menu-p">
                                    TIGPS - Bolpur
                                    <i className="right fas fa-angle-left" />
                                </p>
                            </a>
                            <ul className="nav nav-treeview under-school-block">
                                <li className={`nav-item ${isHomeOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isHomeOpen ? "active" : ""}`} onClick={toggleHome}>
                                        <i className="fas fa-home nav-icon" />
                                        <p className="admin-menu-p">
                                            Home page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Home about section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/home-about-section/bolpur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`}
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home about</p>
                                            </NavLink>
                                        </li>
                                        {/* Achiver Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/achievers/bolpur"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home Achivers</p>
                                            </NavLink>
                                        </li>
                                        {/* WHY CHOOSE US Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/why-choose-us/bolpur"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Why choose us</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAboutOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAboutOpen ? "active" : ""}`} onClick={toggleAbout}>
                                        <i className="fas fa-building nav-icon" />
                                        <p className="admin-menu-p">
                                            About page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* About Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/about-section/bolpur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">About</p>
                                            </NavLink>
                                        </li>
                                        {/* Mission Vision */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/mission-vision-section/bolpur"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mission-Vision</p>
                                            </NavLink>
                                        </li>
                                        {/* Affiliations and Certifications */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/affiliations-certifications-section/bolpur"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Affiliations and Certifications</p>
                                            </NavLink>
                                        </li>
                                        {/* CSR Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/csr-section/bolpur"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">CSR section</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAcademicsOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAcademicsOpen ? "active" : ""}`} onClick={toggleAcademics}>
                                        <i className="nav-icon fas fa-chalkboard-teacher" />
                                        <p className="admin-menu-p">Academics page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                       {/* Mandatory Disclosure */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/academic-page/mandatory-disclosure/bolpur"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mandatory Disclosure</p>
                                            </NavLink>
                                        </li> 
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAdmissionOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAdmissionOpen ? "active" : ""}`} onClick={toggleAdmission}>
                                        <i className="nav-icon fas fa-graduation-cap" />
                                        <p className="admin-menu-p">Admission page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Admission Overview */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-overview/bolpur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Overview </p>
                                            </NavLink>
                                        </li>
                                        {/* Admission Application Procedur Section section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-application-procedure-section/bolpur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Procedure</p>
                                            </NavLink>
                                        </li>
                                        {/* Criteria section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/criteria-section/bolpur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Criteria </p>
                                            </NavLink>
                                        </li>
                                        
                                        {/* School uniform */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/school-uniform/bolpur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">School uniform</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isLifeAtTIGPSOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isLifeAtTIGPSOpen ? "active" : ""}`} onClick={toggleLifeAtTIGPS}>
                                        <i className="nav-icon 	fas fa-school" />
                                        <p className="admin-menu-p">Life at TIGPS</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Pre primary program section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/life-at-tigps-section/bolpur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Beyond academics</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/gallery/bolpur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Gallery</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/videos/bolpur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Videos</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/news-clippings/bolpur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">News clippings</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/event-list/bolpur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Event list</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/newsletter/bolpur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Newsletter</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/techno-echo/bolpur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Techno Echo</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/prospectus/bolpur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Prospectus</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className="nav-item">
                                    <a href="/admin/general-settings/bolpur" className={`nav-link ${isGeneralSettingsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">General settings</p>
                                    </a>
                                </li> 
                                <li className="nav-item">
                                    <a href="/admin/file-upload/bolpur" className={`nav-link ${isFileUploadsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">File upload</p>
                                    </a>
                                </li> 
                            </ul>
                        </li>        

                        {/* -------------- TIGPS Coochbehar ------------ */}
                        <li className={`nav-item school-block mt-2 ${isCoochbeharOpen ? "menu-open" : ""}`}>
                            <a href="#" className={`nav-link ${isCoochbeharOpen ? "active" : ""}`} onClick={toggleCoochbehar}>
                                <i className="nav-icon fas fa-tachometer-alt" />
                                <p className="admin-menu-p">
                                    TIGPS - Coochbehar
                                    <i className="right fas fa-angle-left" />
                                </p>
                            </a>
                            <ul className="nav nav-treeview under-school-block">
                                <li className={`nav-item ${isHomeOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isHomeOpen ? "active" : ""}`} onClick={toggleHome}>
                                        <i className="fas fa-home nav-icon" />
                                        <p className="admin-menu-p">
                                            Home page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Home about section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/home-about-section/coochbehar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`}
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home about</p>
                                            </NavLink>
                                        </li>
                                        {/* Achiver Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/achievers/coochbehar"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home Achivers</p>
                                            </NavLink>
                                        </li>
                                        {/* WHY CHOOSE US Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/why-choose-us/coochbehar"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Why choose us</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAboutOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAboutOpen ? "active" : ""}`} onClick={toggleAbout}>
                                        <i className="fas fa-building nav-icon" />
                                        <p className="admin-menu-p">
                                            About page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* About Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/about-section/coochbehar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">About</p>
                                            </NavLink>
                                        </li>
                                        {/* Mission Vision */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/mission-vision-section/coochbehar"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mission-Vision</p>
                                            </NavLink>
                                        </li>
                                        {/* Affiliations and Certifications */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/affiliations-certifications-section/coochbehar"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Affiliations and Certifications</p>
                                            </NavLink>
                                        </li>
                                        {/* CSR Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/csr-section/coochbehar"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">CSR section</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAcademicsOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAcademicsOpen ? "active" : ""}`} onClick={toggleAcademics}>
                                        <i className="nav-icon fas fa-chalkboard-teacher" />
                                        <p className="admin-menu-p">Academics page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                       {/* Mandatory Disclosure */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/academic-page/mandatory-disclosure/coochbehar"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mandatory Disclosure</p>
                                            </NavLink>
                                        </li> 
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAdmissionOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAdmissionOpen ? "active" : ""}`} onClick={toggleAdmission}>
                                        <i className="nav-icon fas fa-graduation-cap" />
                                        <p className="admin-menu-p">Admission page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Admission Overview */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-overview/coochbehar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Overview </p>
                                            </NavLink>
                                        </li>
                                        {/* Admission Application Procedur Section section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-application-procedure-section/coochbehar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Procedure</p>
                                            </NavLink>
                                        </li>
                                        {/* Criteria section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/criteria-section/coochbehar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Criteria </p>
                                            </NavLink>
                                        </li>
                                        
                                        {/* School uniform */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/school-uniform/coochbehar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">School uniform</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isLifeAtTIGPSOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isLifeAtTIGPSOpen ? "active" : ""}`} onClick={toggleLifeAtTIGPS}>
                                        <i className="nav-icon 	fas fa-school" />
                                        <p className="admin-menu-p">Life at TIGPS</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Pre primary program section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/life-at-tigps-section/coochbehar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Beyond academics</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/gallery/coochbehar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Gallery</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/videos/coochbehar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Videos</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/news-clippings/coochbehar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">News clippings</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/event-list/coochbehar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Event list</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/newsletter/coochbehar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Newsletter</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/techno-echo/coochbehar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Techno Echo</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/prospectus/coochbehar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Prospectus</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className="nav-item">
                                    <a href="/admin/general-settings/coochbehar" className={`nav-link ${isGeneralSettingsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">General settings</p>
                                    </a>
                                </li> 
                                <li className="nav-item">
                                    <a href="/admin/file-upload/coochbehar" className={`nav-link ${isFileUploadsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">File upload</p>
                                    </a>
                                </li> 
                            </ul>
                        </li>               

                        {/* -------------- TIGPS Durgapur ------------ */}
                        <li className={`nav-item school-block mt-2 ${isDurgapurOpen ? "menu-open" : ""}`}>
                            <a href="#" className={`nav-link ${isDurgapurOpen ? "active" : ""}`} onClick={toggleDurgapur}>
                                <i className="nav-icon fas fa-tachometer-alt" />
                                <p className="admin-menu-p">
                                    TIGPS - Durgapur
                                    <i className="right fas fa-angle-left" />
                                </p>
                            </a>
                            <ul className="nav nav-treeview under-school-block">
                                <li className={`nav-item ${isHomeOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isHomeOpen ? "active" : ""}`} onClick={toggleHome}>
                                        <i className="fas fa-home nav-icon" />
                                        <p className="admin-menu-p">
                                            Home page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Home about section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/home-about-section/durgapur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`}
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home about</p>
                                            </NavLink>
                                        </li>
                                        {/* Achiver Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/achievers/durgapur"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home Achivers</p>
                                            </NavLink>
                                        </li>
                                        {/* WHY CHOOSE US Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/why-choose-us/durgapur"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Why choose us</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAboutOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAboutOpen ? "active" : ""}`} onClick={toggleAbout}>
                                        <i className="fas fa-building nav-icon" />
                                        <p className="admin-menu-p">
                                            About page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* About Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/about-section/durgapur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">About</p>
                                            </NavLink>
                                        </li>
                                        {/* Mission Vision */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/mission-vision-section/durgapur"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mission-Vision</p>
                                            </NavLink>
                                        </li>
                                        {/* Affiliations and Certifications */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/affiliations-certifications-section/durgapur"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Affiliations and Certifications</p>
                                            </NavLink>
                                        </li>
                                        {/* CSR Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/csr-section/durgapur"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">CSR section</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAcademicsOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAcademicsOpen ? "active" : ""}`} onClick={toggleAcademics}>
                                        <i className="nav-icon fas fa-chalkboard-teacher" />
                                        <p className="admin-menu-p">Academics page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                       {/* Mandatory Disclosure */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/academic-page/mandatory-disclosure/durgapur"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mandatory Disclosure</p>
                                            </NavLink>
                                        </li> 
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAdmissionOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAdmissionOpen ? "active" : ""}`} onClick={toggleAdmission}>
                                        <i className="nav-icon fas fa-graduation-cap" />
                                        <p className="admin-menu-p">Admission page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Admission Overview */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-overview/durgapur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Overview </p>
                                            </NavLink>
                                        </li>
                                        {/* Admission Application Procedur Section section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-application-procedure-section/durgapur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Procedure</p>
                                            </NavLink>
                                        </li>
                                        {/* Criteria section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/criteria-section/durgapur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Criteria </p>
                                            </NavLink>
                                        </li>
                                        
                                        {/* School uniform */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/school-uniform/durgapur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">School uniform</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isLifeAtTIGPSOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isLifeAtTIGPSOpen ? "active" : ""}`} onClick={toggleLifeAtTIGPS}>
                                        <i className="nav-icon 	fas fa-school" />
                                        <p className="admin-menu-p">Life at TIGPS</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Pre primary program section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/life-at-tigps-section/durgapur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Beyond academics</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/gallery/durgapur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Gallery</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/videos/durgapur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Videos</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/news-clippings/durgapur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">News clippings</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/event-list/durgapur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Event list</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/newsletter/durgapur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Newsletter</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/techno-echo/durgapur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Techno Echo</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/prospectus/durgapur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Prospectus</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className="nav-item">
                                    <a href="/admin/general-settings/durgapur" className={`nav-link ${isGeneralSettingsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">General settings</p>
                                    </a>
                                </li> 
                                <li className="nav-item">
                                    <a href="/admin/file-upload/durgapur" className={`nav-link ${isFileUploadsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">File upload</p>
                                    </a>
                                </li> 
                            </ul>
                        </li> 

                        {/* -------------- TIGPS Falakata ------------ */}
                        <li className={`nav-item school-block mt-2 ${isFalakataOpen ? "menu-open" : ""}`}>
                            <a href="#" className={`nav-link ${isFalakataOpen ? "active" : ""}`} onClick={toggleFalakata}>
                                <i className="nav-icon fas fa-tachometer-alt" />
                                <p className="admin-menu-p">
                                    TIGPS - Falakata
                                    <i className="right fas fa-angle-left" />
                                </p>
                            </a>
                            <ul className="nav nav-treeview under-school-block">
                                <li className={`nav-item ${isHomeOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isHomeOpen ? "active" : ""}`} onClick={toggleHome}>
                                        <i className="fas fa-home nav-icon" />
                                        <p className="admin-menu-p">
                                            Home page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Home about section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/home-about-section/falakata"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`}
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home about</p>
                                            </NavLink>
                                        </li>
                                        {/* Achiver Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/achievers/falakata"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home Achivers</p>
                                            </NavLink>
                                        </li>
                                        {/* WHY CHOOSE US Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/why-choose-us/falakata"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Why choose us</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAboutOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAboutOpen ? "active" : ""}`} onClick={toggleAbout}>
                                        <i className="fas fa-building nav-icon" />
                                        <p className="admin-menu-p">
                                            About page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* About Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/about-section/falakata"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">About</p>
                                            </NavLink>
                                        </li>
                                        {/* Mission Vision */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/mission-vision-section/falakata"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mission-Vision</p>
                                            </NavLink>
                                        </li>
                                        {/* Affiliations and Certifications */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/affiliations-certifications-section/falakata"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Affiliations and Certifications</p>
                                            </NavLink>
                                        </li>
                                        {/* CSR SECTION */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/csr-section/falakata"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">CSR section</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAcademicsOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAcademicsOpen ? "active" : ""}`} onClick={toggleAcademics}>
                                        <i className="nav-icon fas fa-chalkboard-teacher" />
                                        <p className="admin-menu-p">Academics page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                       {/* Mandatory Disclosure */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/academic-page/mandatory-disclosure/falakata"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mandatory Disclosure</p>
                                            </NavLink>
                                        </li> 
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAdmissionOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAdmissionOpen ? "active" : ""}`} onClick={toggleAdmission}>
                                        <i className="nav-icon fas fa-graduation-cap" />
                                        <p className="admin-menu-p">Admission page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Admission Overview */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-overview/falakata"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Overview </p>
                                            </NavLink>
                                        </li>
                                        {/* Admission Application Procedur Section section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-application-procedure-section/falakata"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Procedure</p>
                                            </NavLink>
                                        </li>
                                        {/* Criteria section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/criteria-section/falakata"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Criteria </p>
                                            </NavLink>
                                        </li>
                                        
                                        {/* School uniform */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/school-uniform/falakata"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">School uniform</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isLifeAtTIGPSOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isLifeAtTIGPSOpen ? "active" : ""}`} onClick={toggleLifeAtTIGPS}>
                                        <i className="nav-icon 	fas fa-school" />
                                        <p className="admin-menu-p">Life at TIGPS</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Pre primary program section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/life-at-tigps-section/falakata"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Beyond academics</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/gallery/falakata"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Gallery</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/videos/falakata"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Videos</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/news-clippings/falakata"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">News clippings</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/event-list/falakata"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Event list</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/newsletter/falakata"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Newsletter</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/techno-echo/falakata"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Techno Echo</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/prospectus/falakata"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Prospectus</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className="nav-item">
                                    <a href="/admin/general-settings/falakata" className={`nav-link ${isGeneralSettingsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">General settings</p>
                                    </a>
                                </li> 
                                <li className="nav-item">
                                    <a href="/admin/file-upload/falakata" className={`nav-link ${isFileUploadsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">File upload</p>
                                    </a>
                                </li> 
                            </ul>
                        </li>  

                        {/* -------------- TIGPS Gangarampur ------------ */}
                        <li className={`nav-item school-block mt-2 ${isGangarampurOpen ? "menu-open" : ""}`}>
                            <a href="#" className={`nav-link ${isGangarampurOpen ? "active" : ""}`} onClick={toggleGangarampur}>
                                <i className="nav-icon fas fa-tachometer-alt" />
                                <p className="admin-menu-p">
                                    TIGPS - Gangarampur
                                    <i className="right fas fa-angle-left" />
                                </p>
                            </a>
                            <ul className="nav nav-treeview under-school-block">
                                <li className={`nav-item ${isHomeOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isHomeOpen ? "active" : ""}`} onClick={toggleHome}>
                                        <i className="fas fa-home nav-icon" />
                                        <p className="admin-menu-p">
                                            Home page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Home about section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/home-about-section/gangarampur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`}
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home about</p>
                                            </NavLink>
                                        </li>
                                        {/* Achiver Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/achievers/gangarampur"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home Achivers</p>
                                            </NavLink>
                                        </li>
                                        {/* WHY CHOOSE US Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/why-choose-us/gangarampur"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Why choose us</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAboutOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAboutOpen ? "active" : ""}`} onClick={toggleAbout}>
                                        <i className="fas fa-building nav-icon" />
                                        <p className="admin-menu-p">
                                            About page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* About Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/about-section/gangarampur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">About</p>
                                            </NavLink>
                                        </li>
                                        {/* Mission Vision */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/mission-vision-section/gangarampur"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mission-Vision</p>
                                            </NavLink>
                                        </li>
                                        {/* Affiliations and Certifications */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/affiliations-certifications-section/gangarampur"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Affiliations and Certifications</p>
                                            </NavLink>
                                        </li>
                                        {/* CSR Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/csr-section/gangarampur"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">CSR section</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAcademicsOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAcademicsOpen ? "active" : ""}`} onClick={toggleAcademics}>
                                        <i className="nav-icon fas fa-chalkboard-teacher" />
                                        <p className="admin-menu-p">Academics page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                       {/* Mandatory Disclosure */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/academic-page/mandatory-disclosure/gangarampur"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mandatory Disclosure</p>
                                            </NavLink>
                                        </li> 
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAdmissionOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAdmissionOpen ? "active" : ""}`} onClick={toggleAdmission}>
                                        <i className="nav-icon fas fa-graduation-cap" />
                                        <p className="admin-menu-p">Admission page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Admission Overview */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-overview/gangarampur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Overview </p>
                                            </NavLink>
                                        </li>
                                        {/* Admission Application Procedur Section section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-application-procedure-section/gangarampur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Procedure</p>
                                            </NavLink>
                                        </li>
                                        {/* Criteria section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/criteria-section/gangarampur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Criteria </p>
                                            </NavLink>
                                        </li>
                                        
                                        {/* School uniform */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/school-uniform/gangarampur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">School uniform</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isLifeAtTIGPSOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isLifeAtTIGPSOpen ? "active" : ""}`} onClick={toggleLifeAtTIGPS}>
                                        <i className="nav-icon 	fas fa-school" />
                                        <p className="admin-menu-p">Life at TIGPS</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Pre primary program section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/life-at-tigps-section/gangarampur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Beyond academics</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/gallery/gangarampur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Gallery</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/videos/gangarampur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Videos</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/news-clippings/gangarampur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">News clippings</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/event-list/gangarampur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Event list</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/newsletter/gangarampur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Newsletter</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/techno-echo/gangarampur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Techno Echo</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/prospectus/gangarampur"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Prospectus</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className="nav-item">
                                    <a href="/admin/general-settings/gangarampur" className={`nav-link ${isGeneralSettingsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">General settings</p>
                                    </a>
                                </li> 
                                <li className="nav-item">
                                    <a href="/admin/file-upload/gangarampur" className={`nav-link ${isFileUploadsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">File upload</p>
                                    </a>
                                </li> 
                            </ul>
                        </li>  

                        {/* -------------- TIGPS Hooghly ------------ */}
                        <li className={`nav-item school-block mt-2 ${isHooghlyOpen ? "menu-open" : ""}`}>
                            <a href="#" className={`nav-link ${isHooghlyOpen ? "active" : ""}`} onClick={toggleHooghly}>
                                <i className="nav-icon fas fa-tachometer-alt" />
                                <p className="admin-menu-p">
                                    TIGPS - Hooghly
                                    <i className="right fas fa-angle-left" />
                                </p>
                            </a>
                            <ul className="nav nav-treeview under-school-block">
                                <li className={`nav-item ${isHomeOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isHomeOpen ? "active" : ""}`} onClick={toggleHome}>
                                        <i className="fas fa-home nav-icon" />
                                        <p className="admin-menu-p">
                                            Home page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Home about section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/home-about-section/hooghly"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`}
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home about</p>
                                            </NavLink>
                                        </li>
                                        {/* Achiver Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/achievers/hooghly"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home Achivers</p>
                                            </NavLink>
                                        </li>
                                        {/* WHY CHOOSE US Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/why-choose-us/hooghly"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Why choose us</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAboutOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAboutOpen ? "active" : ""}`} onClick={toggleAbout}>
                                        <i className="fas fa-building nav-icon" />
                                        <p className="admin-menu-p">
                                            About page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* About Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/about-section/hooghly"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">About</p>
                                            </NavLink>
                                        </li>
                                        {/* Mission Vision */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/mission-vision-section/hooghly"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mission-Vision</p>
                                            </NavLink>
                                        </li>
                                        {/* Affiliations and Certifications */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/affiliations-certifications-section/hooghly"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Affiliations and Certifications</p>
                                            </NavLink>
                                        </li>
                                        {/* CSR SECTION */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/csr-section/hooghly"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">CSR section</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAcademicsOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAcademicsOpen ? "active" : ""}`} onClick={toggleAcademics}>
                                        <i className="nav-icon fas fa-chalkboard-teacher" />
                                        <p className="admin-menu-p">Academics page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                       {/* Mandatory Disclosure */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/academic-page/mandatory-disclosure/hooghly"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mandatory Disclosure</p>
                                            </NavLink>
                                        </li> 
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAdmissionOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAdmissionOpen ? "active" : ""}`} onClick={toggleAdmission}>
                                        <i className="nav-icon fas fa-graduation-cap" />
                                        <p className="admin-menu-p">Admission page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Admission Overview */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-overview/hooghly"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Overview </p>
                                            </NavLink>
                                        </li>
                                        {/* Admission Application Procedur Section section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-application-procedure-section/hooghly"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Procedure</p>
                                            </NavLink>
                                        </li>
                                        {/* Criteria section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/criteria-section/hooghly"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Criteria </p>
                                            </NavLink>
                                        </li>
                                        
                                        {/* School uniform */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/school-uniform/hooghly"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">School uniform</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isLifeAtTIGPSOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isLifeAtTIGPSOpen ? "active" : ""}`} onClick={toggleLifeAtTIGPS}>
                                        <i className="nav-icon 	fas fa-school" />
                                        <p className="admin-menu-p">Life at TIGPS</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Pre primary program section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/life-at-tigps-section/hooghly"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Beyond academics</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/gallery/hooghly"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Gallery</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/videos/hooghly"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Videos</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/news-clippings/hooghly"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">News clippings</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/event-list/hooghly"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Event list</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/newsletter/hooghly"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Newsletter</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/techno-echo/hooghly"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Techno Echo</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/prospectus/hooghly"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Prospectus</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className="nav-item">
                                    <a href="/admin/general-settings/hooghly" className={`nav-link ${isGeneralSettingsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">General settings</p>
                                    </a>
                                </li> 
                                <li className="nav-item">
                                    <a href="/admin/file-upload/hooghly" className={`nav-link ${isFileUploadsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">File upload</p>
                                    </a>
                                </li> 
                            </ul>
                        </li>  

                        {/* -------------- TIGPS Jalpaiguri ------------ */}
                        <li className={`nav-item school-block mt-2 ${isJalpaiguriOpen ? "menu-open" : ""}`}>
                            <a href="#" className={`nav-link ${isJalpaiguriOpen ? "active" : ""}`} onClick={toggleJalpaiguri}>
                                <i className="nav-icon fas fa-tachometer-alt" />
                                <p className="admin-menu-p">
                                    TIGPS - Jalpaiguri
                                    <i className="right fas fa-angle-left" />
                                </p>
                            </a>
                            <ul className="nav nav-treeview under-school-block">
                                <li className={`nav-item ${isHomeOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isHomeOpen ? "active" : ""}`} onClick={toggleHome}>
                                        <i className="fas fa-home nav-icon" />
                                        <p className="admin-menu-p">
                                            Home page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Home about section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/home-about-section/jalpaiguri"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`}
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home about</p>
                                            </NavLink>
                                        </li>
                                        {/* Achiver Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/achievers/jalpaiguri"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home Achivers</p>
                                            </NavLink>
                                        </li>
                                        {/* WHY CHOOSE US Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/why-choose-us/jalpaiguri"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Why choose us</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAboutOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAboutOpen ? "active" : ""}`} onClick={toggleAbout}>
                                        <i className="fas fa-building nav-icon" />
                                        <p className="admin-menu-p">
                                            About page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* About Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/about-section/jalpaiguri"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">About</p>
                                            </NavLink>
                                        </li>
                                        {/* Mission Vision */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/mission-vision-section/jalpaiguri"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mission-Vision</p>
                                            </NavLink>
                                        </li>
                                        {/* Affiliations and Certifications */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/affiliations-certifications-section/jalpaiguri"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Affiliations and Certifications</p>
                                            </NavLink>
                                        </li>
                                        {/* CSR SECTION */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/csr-section/jalpaiguri"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">CSR section</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAcademicsOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAcademicsOpen ? "active" : ""}`} onClick={toggleAcademics}>
                                        <i className="nav-icon fas fa-chalkboard-teacher" />
                                        <p className="admin-menu-p">Academics page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                       {/* Mandatory Disclosure */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/academic-page/mandatory-disclosure/jalpaiguri"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mandatory Disclosure</p>
                                            </NavLink>
                                        </li> 
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAdmissionOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAdmissionOpen ? "active" : ""}`} onClick={toggleAdmission}>
                                        <i className="nav-icon fas fa-graduation-cap" />
                                        <p className="admin-menu-p">Admission page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Admission Overview */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-overview/jalpaiguri"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Overview </p>
                                            </NavLink>
                                        </li>
                                        {/* Admission Application Procedur Section section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-application-procedure-section/jalpaiguri"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Procedure</p>
                                            </NavLink>
                                        </li>
                                        {/* Criteria section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/criteria-section/jalpaiguri"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Criteria </p>
                                            </NavLink>
                                        </li>
                                        
                                        {/* School uniform */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/school-uniform/jalpaiguri"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">School uniform</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isLifeAtTIGPSOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isLifeAtTIGPSOpen ? "active" : ""}`} onClick={toggleLifeAtTIGPS}>
                                        <i className="nav-icon 	fas fa-school" />
                                        <p className="admin-menu-p">Life at TIGPS</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Pre primary program section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/life-at-tigps-section/jalpaiguri"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Beyond academics</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/gallery/jalpaiguri"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Gallery</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/videos/jalpaiguri"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Videos</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/news-clippings/jalpaiguri"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">News clippings</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/event-list/jalpaiguri"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Event list</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/newsletter/jalpaiguri"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Newsletter</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/techno-echo/jalpaiguri"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Techno Echo</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/prospectus/jalpaiguri"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Prospectus</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className="nav-item">
                                    <a href="/admin/general-settings/jalpaiguri" className={`nav-link ${isGeneralSettingsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">General settings</p>
                                    </a>
                                </li> 
                                <li className="nav-item">
                                    <a href="/admin/file-upload/jalpaiguri" className={`nav-link ${isFileUploadsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">File upload</p>
                                    </a>
                                </li> 
                            </ul>
                        </li>   

                        {/* -------------- TIGPS Kolaghat ------------ */}
                        <li className={`nav-item school-block mt-2 ${isKolaghatOpen ? "menu-open" : ""}`}>
                            <a href="#" className={`nav-link ${isKolaghatOpen ? "active" : ""}`} onClick={toggleKolaghat}>
                                <i className="nav-icon fas fa-tachometer-alt" />
                                <p className="admin-menu-p">
                                    TIGPS - Kolaghat
                                    <i className="right fas fa-angle-left" />
                                </p>
                            </a>
                            <ul className="nav nav-treeview under-school-block">
                                <li className={`nav-item ${isHomeOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isHomeOpen ? "active" : ""}`} onClick={toggleHome}>
                                        <i className="fas fa-home nav-icon" />
                                        <p className="admin-menu-p">
                                            Home page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Home about section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/home-about-section/kolaghat"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`}
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home about</p>
                                            </NavLink>
                                        </li>
                                        {/* Achiver Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/achievers/kolaghat"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home Achivers</p>
                                            </NavLink>
                                        </li>
                                        {/* WHY CHOOSE US Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/why-choose-us/kolaghat"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Why choose us</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAboutOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAboutOpen ? "active" : ""}`} onClick={toggleAbout}>
                                        <i className="fas fa-building nav-icon" />
                                        <p className="admin-menu-p">
                                            About page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* About Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/about-section/kolaghat"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">About</p>
                                            </NavLink>
                                        </li>
                                        {/* Mission Vision */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/mission-vision-section/kolaghat"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mission-Vision</p>
                                            </NavLink>
                                        </li>
                                        {/* Affiliations and Certifications */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/affiliations-certifications-section/kolaghat"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Affiliations and Certifications</p>
                                            </NavLink>
                                        </li>
                                        {/* CSR Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/csr-section/kolaghat"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">CSR section</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAcademicsOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAcademicsOpen ? "active" : ""}`} onClick={toggleAcademics}>
                                        <i className="nav-icon fas fa-chalkboard-teacher" />
                                        <p className="admin-menu-p">Academics page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                       {/* Mandatory Disclosure */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/academic-page/mandatory-disclosure/kolaghat"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mandatory Disclosure</p>
                                            </NavLink>
                                        </li> 
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAdmissionOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAdmissionOpen ? "active" : ""}`} onClick={toggleAdmission}>
                                        <i className="nav-icon fas fa-graduation-cap" />
                                        <p className="admin-menu-p">Admission page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Admission Overview */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-overview/kolaghat"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Overview </p>
                                            </NavLink>
                                        </li>
                                        {/* Admission Application Procedur Section section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-application-procedure-section/kolaghat"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Procedure</p>
                                            </NavLink>
                                        </li>
                                        {/* Criteria section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/criteria-section/kolaghat"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Criteria </p>
                                            </NavLink>
                                        </li>
                                        
                                        {/* School uniform */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/school-uniform/kolaghat"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">School uniform</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isLifeAtTIGPSOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isLifeAtTIGPSOpen ? "active" : ""}`} onClick={toggleLifeAtTIGPS}>
                                        <i className="nav-icon 	fas fa-school" />
                                        <p className="admin-menu-p">Life at TIGPS</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Pre primary program section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/life-at-tigps-section/kolaghat"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Beyond academics</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/gallery/kolaghat"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Gallery</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/videos/kolaghat"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Videos</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/news-clippings/kolaghat"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">News clippings</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/event-list/kolaghat"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Event list</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/newsletter/kolaghat"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Newsletter</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/techno-echo/kolaghat"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Techno Echo</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/prospectus/kolaghat"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Prospectus</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className="nav-item">
                                    <a href="/admin/general-settings/kolaghat" className={`nav-link ${isGeneralSettingsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">General settings</p>
                                    </a>
                                </li> 
                                <li className="nav-item">
                                    <a href="/admin/file-upload/kolaghat" className={`nav-link ${isFileUploadsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">File upload</p>
                                    </a>
                                </li> 
                            </ul>
                        </li>      

                        {/* -------------- TIGPS Krishnanagar ------------ */}
                        <li className={`nav-item school-block mt-2 ${isKrishnanagarOpen ? "menu-open" : ""}`}>
                            <a href="#" className={`nav-link ${isKrishnanagarOpen ? "active" : ""}`} onClick={toggleKrishnanagar}>
                                <i className="nav-icon fas fa-tachometer-alt" />
                                <p className="admin-menu-p">
                                    TIGPS - Krishnanagar
                                    <i className="right fas fa-angle-left" />
                                </p>
                            </a>
                            <ul className="nav nav-treeview under-school-block">
                                <li className={`nav-item ${isHomeOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isHomeOpen ? "active" : ""}`} onClick={toggleHome}>
                                        <i className="fas fa-home nav-icon" />
                                        <p className="admin-menu-p">
                                            Home page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Home about section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/home-about-section/krishnanagar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`}
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home about</p>
                                            </NavLink>
                                        </li>
                                        {/* Achiver Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/achievers/krishnanagar"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home Achivers</p>
                                            </NavLink>
                                        </li>
                                        {/* WHY CHOOSE US Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/why-choose-us/krishnanagar"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Why choose us</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAboutOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAboutOpen ? "active" : ""}`} onClick={toggleAbout}>
                                        <i className="fas fa-building nav-icon" />
                                        <p className="admin-menu-p">
                                            About page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* About Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/about-section/krishnanagar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">About</p>
                                            </NavLink>
                                        </li>
                                        {/* Mission Vision */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/mission-vision-section/krishnanagar"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mission-Vision</p>
                                            </NavLink>
                                        </li>
                                        {/* Affiliations and Certifications */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/affiliations-certifications-section/krishnanagar"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Affiliations and Certifications</p>
                                            </NavLink>
                                        </li>
                                        {/* CSR Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/csr-section/krishnanagar"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">CSR section</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAcademicsOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAcademicsOpen ? "active" : ""}`} onClick={toggleAcademics}>
                                        <i className="nav-icon fas fa-chalkboard-teacher" />
                                        <p className="admin-menu-p">Academics page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                       {/* Mandatory Disclosure */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/academic-page/mandatory-disclosure/krishnanagar"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mandatory Disclosure</p>
                                            </NavLink>
                                        </li> 
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAdmissionOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAdmissionOpen ? "active" : ""}`} onClick={toggleAdmission}>
                                        <i className="nav-icon fas fa-graduation-cap" />
                                        <p className="admin-menu-p">Admission page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Admission Overview */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-overview/krishnanagar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Overview </p>
                                            </NavLink>
                                        </li>
                                        {/* Admission Application Procedur Section section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-application-procedure-section/krishnanagar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Procedure</p>
                                            </NavLink>
                                        </li>
                                        {/* Criteria section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/criteria-section/krishnanagar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Criteria </p>
                                            </NavLink>
                                        </li>
                                        
                                        {/* School uniform */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/school-uniform/krishnanagar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">School uniform</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isLifeAtTIGPSOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isLifeAtTIGPSOpen ? "active" : ""}`} onClick={toggleLifeAtTIGPS}>
                                        <i className="nav-icon 	fas fa-school" />
                                        <p className="admin-menu-p">Life at TIGPS</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Pre primary program section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/life-at-tigps-section/krishnanagar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Beyond academics</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/gallery/krishnanagar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Gallery</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/videos/krishnanagar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Videos</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/news-clippings/krishnanagar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">News clippings</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/event-list/krishnanagar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Event list</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/newsletter/krishnanagar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Newsletter</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/techno-echo/krishnanagar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Techno Echo</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/prospectus/krishnanagar"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Prospectus</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className="nav-item">
                                    <a href="/admin/general-settings/krishnanagar" className={`nav-link ${isGeneralSettingsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">General settings</p>
                                    </a>
                                </li> 
                                <li className="nav-item">
                                    <a href="/admin/file-upload/krishnanagar" className={`nav-link ${isFileUploadsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">File upload</p>
                                    </a>
                                </li> 
                            </ul>
                        </li> 

                        {/* -------------- TIGPS Midnapore ------------ */}
                        <li className={`nav-item school-block mt-2 ${isMidnaporeOpen ? "menu-open" : ""}`}>
                            <a href="#" className={`nav-link ${isMidnaporeOpen ? "active" : ""}`} onClick={toggleMidnapore}>
                                <i className="nav-icon fas fa-tachometer-alt" />
                                <p className="admin-menu-p">
                                    TIGPS - Midnapore
                                    <i className="right fas fa-angle-left" />
                                </p>
                            </a>
                            <ul className="nav nav-treeview under-school-block">
                                <li className={`nav-item ${isHomeOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isHomeOpen ? "active" : ""}`} onClick={toggleHome}>
                                        <i className="fas fa-home nav-icon" />
                                        <p className="admin-menu-p">
                                            Home page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Home about section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/home-about-section/midnapore"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`}
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home about</p>
                                            </NavLink>
                                        </li>
                                        {/* Achiver Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/achievers/midnapore"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home Achivers</p>
                                            </NavLink>
                                        </li>
                                        {/* WHY CHOOSE US Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/why-choose-us/midnapore"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Why choose us</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAboutOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAboutOpen ? "active" : ""}`} onClick={toggleAbout}>
                                        <i className="fas fa-building nav-icon" />
                                        <p className="admin-menu-p">
                                            About page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* About Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/about-section/midnapore"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">About</p>
                                            </NavLink>
                                        </li>
                                        {/* Mission Vision */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/mission-vision-section/midnapore"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mission-Vision</p>
                                            </NavLink>
                                        </li>
                                        {/* Affiliations and Certifications */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/affiliations-certifications-section/midnapore"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Affiliations and Certifications</p>
                                            </NavLink>
                                        </li>
                                        {/* CSR SECTION */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/csr-section/midnapore"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">CSR section</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAcademicsOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAcademicsOpen ? "active" : ""}`} onClick={toggleAcademics}>
                                        <i className="nav-icon fas fa-chalkboard-teacher" />
                                        <p className="admin-menu-p">Academics page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                       {/* Mandatory Disclosure */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/academic-page/mandatory-disclosure/midnapore"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mandatory Disclosure</p>
                                            </NavLink>
                                        </li> 
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAdmissionOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAdmissionOpen ? "active" : ""}`} onClick={toggleAdmission}>
                                        <i className="nav-icon fas fa-graduation-cap" />
                                        <p className="admin-menu-p">Admission page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Admission Overview */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-overview/midnapore"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Overview </p>
                                            </NavLink>
                                        </li>
                                        {/* Admission Application Procedur Section section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-application-procedure-section/midnapore"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Procedure</p>
                                            </NavLink>
                                        </li>
                                        {/* Criteria section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/criteria-section/midnapore"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Criteria </p>
                                            </NavLink>
                                        </li>
                                        
                                        {/* School uniform */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/school-uniform/midnapore"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">School uniform</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isLifeAtTIGPSOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isLifeAtTIGPSOpen ? "active" : ""}`} onClick={toggleLifeAtTIGPS}>
                                        <i className="nav-icon 	fas fa-school" />
                                        <p className="admin-menu-p">Life at TIGPS</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Pre primary program section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/life-at-tigps-section/midnapore"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Beyond academics</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/gallery/midnapore"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Gallery</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/videos/midnapore"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Videos</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/news-clippings/midnapore"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">News clippings</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/event-list/midnapore"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Event list</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/newsletter/midnapore"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Newsletter</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/techno-echo/midnapore"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Techno Echo</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/prospectus/midnapore"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Prospectus</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className="nav-item">
                                    <a href="/admin/general-settings/midnapore" className={`nav-link ${isGeneralSettingsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">General settings</p>
                                    </a>
                                </li> 
                                <li className="nav-item">
                                    <a href="/admin/file-upload/midnapore" className={`nav-link ${isFileUploadsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">File upload</p>
                                    </a>
                                </li> 
                            </ul>
                        </li>  

                        {/* -------------- TIGPS Nabadwip ------------ */}
                        <li className={`nav-item school-block mt-2 ${isNabadwipOpen ? "menu-open" : ""}`}>
                            <a href="#" className={`nav-link ${isNabadwipOpen ? "active" : ""}`} onClick={toggleNabadwip}>
                                <i className="nav-icon fas fa-tachometer-alt" />
                                <p className="admin-menu-p">
                                    TIGPS - Nabadwip
                                    <i className="right fas fa-angle-left" />
                                </p>
                            </a>
                            <ul className="nav nav-treeview under-school-block">
                                <li className={`nav-item ${isHomeOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isHomeOpen ? "active" : ""}`} onClick={toggleHome}>
                                        <i className="fas fa-home nav-icon" />
                                        <p className="admin-menu-p">
                                            Home page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Home about section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/home-about-section/nabadwip"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`}
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home about</p>
                                            </NavLink>
                                        </li>
                                        {/* Achiver Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/achievers/nabadwip"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home Achivers</p>
                                            </NavLink>
                                        </li>
                                        {/* WHY CHOOSE US Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/why-choose-us/nabadwip"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Why choose us</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAboutOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAboutOpen ? "active" : ""}`} onClick={toggleAbout}>
                                        <i className="fas fa-building nav-icon" />
                                        <p className="admin-menu-p">
                                            About page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* About Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/about-section/nabadwip"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">About</p>
                                            </NavLink>
                                        </li>
                                        {/* Mission Vision */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/mission-vision-section/nabadwip"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mission-Vision</p>
                                            </NavLink>
                                        </li>
                                        {/* Affiliations and Certifications */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/affiliations-certifications-section/nabadwip"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Affiliations and Certifications</p>
                                            </NavLink>
                                        </li>
                                        {/* CSR Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/csr-section/nabadwip"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">CSR section</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAcademicsOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAcademicsOpen ? "active" : ""}`} onClick={toggleAcademics}>
                                        <i className="nav-icon fas fa-chalkboard-teacher" />
                                        <p className="admin-menu-p">Academics page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                       {/* Mandatory Disclosure */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/academic-page/mandatory-disclosure/nabadwip"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mandatory Disclosure</p>
                                            </NavLink>
                                        </li> 
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAdmissionOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAdmissionOpen ? "active" : ""}`} onClick={toggleAdmission}>
                                        <i className="nav-icon fas fa-graduation-cap" />
                                        <p className="admin-menu-p">Admission page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Admission Overview */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-overview/nabadwip"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Overview </p>
                                            </NavLink>
                                        </li>
                                        {/* Admission Application Procedur Section section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-application-procedure-section/nabadwip"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Procedure</p>
                                            </NavLink>
                                        </li>
                                        {/* Criteria section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/criteria-section/nabadwip"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Criteria </p>
                                            </NavLink>
                                        </li>
                                        
                                        {/* School uniform */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/school-uniform/nabadwip"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">School uniform</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isLifeAtTIGPSOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isLifeAtTIGPSOpen ? "active" : ""}`} onClick={toggleLifeAtTIGPS}>
                                        <i className="nav-icon 	fas fa-school" />
                                        <p className="admin-menu-p">Life at TIGPS</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Pre primary program section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/life-at-tigps-section/nabadwip"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Beyond academics</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/gallery/nabadwip"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Gallery</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/videos/nabadwip"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Videos</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/news-clippings/nabadwip"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">News clippings</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/event-list/nabadwip"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Event list</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/newsletter/nabadwip"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Newsletter</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/techno-echo/nabadwip"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Techno Echo</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/prospectus/nabadwip"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Prospectus</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className="nav-item">
                                    <a href="/admin/general-settings/nabadwip" className={`nav-link ${isGeneralSettingsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">General settings</p>
                                    </a>
                                </li> 
                                <li className="nav-item">
                                    <a href="/admin/file-upload/nabadwip" className={`nav-link ${isFileUploadsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">File upload</p>
                                    </a>
                                </li> 
                            </ul>
                        </li>   

                        {/* -------------- TIGPS Raiganj ------------ */}
                        <li className={`nav-item school-block mt-2 ${isRaiganjOpen ? "menu-open" : ""}`}>
                            <a href="#" className={`nav-link ${isRaiganjOpen ? "active" : ""}`} onClick={toggleRaiganj}>
                                <i className="nav-icon fas fa-tachometer-alt" />
                                <p className="admin-menu-p">
                                    TIGPS - Raiganj
                                    <i className="right fas fa-angle-left" />
                                </p>
                            </a>
                            <ul className="nav nav-treeview under-school-block">
                                <li className={`nav-item ${isHomeOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isHomeOpen ? "active" : ""}`} onClick={toggleHome}>
                                        <i className="fas fa-home nav-icon" />
                                        <p className="admin-menu-p">
                                            Home page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Home about section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/home-about-section/raiganj"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`}
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home about</p>
                                            </NavLink>
                                        </li>
                                        {/* Achiver Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/achievers/raiganj"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home Achivers</p>
                                            </NavLink>
                                        </li>
                                        {/* WHY CHOOSE US Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/why-choose-us/raiganj"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Why choose us</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAboutOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAboutOpen ? "active" : ""}`} onClick={toggleAbout}>
                                        <i className="fas fa-building nav-icon" />
                                        <p className="admin-menu-p">
                                            About page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* About Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/about-section/raiganj"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">About</p>
                                            </NavLink>
                                        </li>
                                        {/* Mission Vision */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/mission-vision-section/raiganj"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mission-Vision</p>
                                            </NavLink>
                                        </li>
                                        {/* Affiliations and Certifications */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/affiliations-certifications-section/raiganj"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Affiliations and Certifications</p>
                                            </NavLink>
                                        </li>
                                        {/* CSR SECTION */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/csr-section/raiganj"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">CSR section</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAcademicsOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAcademicsOpen ? "active" : ""}`} onClick={toggleAcademics}>
                                        <i className="nav-icon fas fa-chalkboard-teacher" />
                                        <p className="admin-menu-p">Academics page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                       {/* Mandatory Disclosure */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/academic-page/mandatory-disclosure/raiganj"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mandatory Disclosure</p>
                                            </NavLink>
                                        </li> 
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAdmissionOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAdmissionOpen ? "active" : ""}`} onClick={toggleAdmission}>
                                        <i className="nav-icon fas fa-graduation-cap" />
                                        <p className="admin-menu-p">Admission page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Admission Overview */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-overview/raiganj"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Overview </p>
                                            </NavLink>
                                        </li>
                                        {/* Admission Application Procedur Section section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-application-procedure-section/raiganj"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Procedure</p>
                                            </NavLink>
                                        </li>
                                        {/* Criteria section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/criteria-section/raiganj"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Criteria </p>
                                            </NavLink>
                                        </li>
                                        
                                        {/* School uniform */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/school-uniform/raiganj"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">School uniform</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isLifeAtTIGPSOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isLifeAtTIGPSOpen ? "active" : ""}`} onClick={toggleLifeAtTIGPS}>
                                        <i className="nav-icon 	fas fa-school" />
                                        <p className="admin-menu-p">Life at TIGPS</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Pre primary program section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/life-at-tigps-section/raiganj"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Beyond academics</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/gallery/raiganj"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Gallery</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/videos/raiganj"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Videos</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/news-clippings/raiganj"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">News clippings</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/event-list/raiganj"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Event list</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/newsletter/raiganj"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Newsletter</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/techno-echo/raiganj"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Techno Echo</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/prospectus/raiganj"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Prospectus</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className="nav-item">
                                    <a href="/admin/general-settings/raiganj" className={`nav-link ${isGeneralSettingsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">General settings</p>
                                    </a>
                                </li> 
                                <li className="nav-item">
                                    <a href="/admin/file-upload/raiganj" className={`nav-link ${isFileUploadsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">File upload</p>
                                    </a>
                                </li> 
                            </ul>
                        </li>    

                        {/* -------------- TIGPS Raniganj ------------ */}
                        <li className={`nav-item school-block mt-2 ${isRaniganjOpen ? "menu-open" : ""}`}>
                            <a href="#" className={`nav-link ${isRaniganjOpen ? "active" : ""}`} onClick={toggleRaniganj}>
                                <i className="nav-icon fas fa-tachometer-alt" />
                                <p className="admin-menu-p">
                                    TIGPS - Raniganj
                                    <i className="right fas fa-angle-left" />
                                </p>
                            </a>
                            <ul className="nav nav-treeview under-school-block">
                                <li className={`nav-item ${isHomeOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isHomeOpen ? "active" : ""}`} onClick={toggleHome}>
                                        <i className="fas fa-home nav-icon" />
                                        <p className="admin-menu-p">
                                            Home page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Home about section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/home-about-section/raniganj"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`}
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home about</p>
                                            </NavLink>
                                        </li>
                                        {/* Achiver Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/achievers/raniganj"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home Achivers</p>
                                            </NavLink>
                                        </li>
                                        {/* WHY CHOOSE US Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/why-choose-us/raniganj"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Why choose us</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAboutOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAboutOpen ? "active" : ""}`} onClick={toggleAbout}>
                                        <i className="fas fa-building nav-icon" />
                                        <p className="admin-menu-p">
                                            About page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* About Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/about-section/raniganj"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">About</p>
                                            </NavLink>
                                        </li>
                                        {/* Mission Vision */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/mission-vision-section/raniganj"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mission-Vision</p>
                                            </NavLink>
                                        </li>
                                        {/* Affiliations and Certifications */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/affiliations-certifications-section/raniganj"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Affiliations and Certifications</p>
                                            </NavLink>
                                        </li>
                                        {/* CSR SECTION */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/csr-section/raniganj"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">CSR section</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAcademicsOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAcademicsOpen ? "active" : ""}`} onClick={toggleAcademics}>
                                        <i className="nav-icon fas fa-chalkboard-teacher" />
                                        <p className="admin-menu-p">Academics page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                       {/* Mandatory Disclosure */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/academic-page/mandatory-disclosure/raniganj"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mandatory Disclosure</p>
                                            </NavLink>
                                        </li> 
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAdmissionOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAdmissionOpen ? "active" : ""}`} onClick={toggleAdmission}>
                                        <i className="nav-icon fas fa-graduation-cap" />
                                        <p className="admin-menu-p">Admission page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Admission Overview */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-overview/raniganj"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Overview </p>
                                            </NavLink>
                                        </li>
                                        {/* Admission Application Procedur Section section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-application-procedure-section/raniganj"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Procedure</p>
                                            </NavLink>
                                        </li>
                                        {/* Criteria section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/criteria-section/raniganj"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Criteria </p>
                                            </NavLink>
                                        </li>
                                        
                                        {/* School uniform */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/school-uniform/raniganj"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">School uniform</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isLifeAtTIGPSOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isLifeAtTIGPSOpen ? "active" : ""}`} onClick={toggleLifeAtTIGPS}>
                                        <i className="nav-icon 	fas fa-school" />
                                        <p className="admin-menu-p">Life at TIGPS</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Pre primary program section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/life-at-tigps-section/raniganj"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Beyond academics</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/gallery/raniganj"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Gallery</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/videos/raniganj"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Videos</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/news-clippings/raniganj"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">News clippings</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/event-list/raniganj"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Event list</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/newsletter/raniganj"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Newsletter</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/techno-echo/raniganj"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Techno Echo</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/prospectus/raniganj"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Prospectus</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className="nav-item">
                                    <a href="/admin/general-settings/raniganj" className={`nav-link ${isGeneralSettingsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">General settings</p>
                                    </a>
                                </li> 
                                <li className="nav-item">
                                    <a href="/admin/file-upload/raniganj" className={`nav-link ${isFileUploadsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">File upload</p>
                                    </a>
                                </li> 
                            </ul>
                        </li>    

                        {/* -------------- TIGPS Siliguri ------------ */}
                        <li className={`nav-item school-block mt-2 ${isSiliguriOpen ? "menu-open" : ""}`}>
                            <a href="#" className={`nav-link ${isSiliguriOpen ? "active" : ""}`} onClick={toggleSiliguri}>
                                <i className="nav-icon fas fa-tachometer-alt" />
                                <p className="admin-menu-p">
                                    TIGPS - Siliguri
                                    <i className="right fas fa-angle-left" />
                                </p>
                            </a>
                            <ul className="nav nav-treeview under-school-block">
                                <li className={`nav-item ${isHomeOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isHomeOpen ? "active" : ""}`} onClick={toggleHome}>
                                        <i className="fas fa-home nav-icon" />
                                        <p className="admin-menu-p">
                                            Home page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Home about section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/home-about-section/siliguri"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`}
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home about</p>
                                            </NavLink>
                                        </li>
                                        {/* Achiver Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/achievers/siliguri"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Home Achivers</p>
                                            </NavLink>
                                        </li>
                                        {/* WHY CHOOSE US Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/home-page/why-choose-us/siliguri"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Why choose us</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAboutOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAboutOpen ? "active" : ""}`} onClick={toggleAbout}>
                                        <i className="fas fa-building nav-icon" />
                                        <p className="admin-menu-p">
                                            About page
                                            <i className="right fas fa-angle-left" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* About Section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/about-section/siliguri"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">About</p>
                                            </NavLink>
                                        </li>
                                        {/* Mission Vision */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/mission-vision-section/siliguri"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mission-Vision</p>
                                            </NavLink>
                                        </li>
                                        {/* Affiliations and Certifications */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/affiliations-certifications-section/siliguri"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Affiliations and Certifications</p>
                                            </NavLink>
                                        </li>
                                        {/* CSR section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/about-page/csr-section/siliguri"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">CSR section</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAcademicsOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAcademicsOpen ? "active" : ""}`} onClick={toggleAcademics}>
                                        <i className="nav-icon fas fa-chalkboard-teacher" />
                                        <p className="admin-menu-p">Academics page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                       {/* Mandatory Disclosure */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/academic-page/mandatory-disclosure/siliguri"
                                                className={({ isMissionVision }) =>
                                                    `nav-link ${isMissionVision ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Mandatory Disclosure</p>
                                            </NavLink>
                                        </li> 
                                    </ul>
                                </li>
                                <li className={`nav-item ${isAdmissionOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isAdmissionOpen ? "active" : ""}`} onClick={toggleAdmission}>
                                        <i className="nav-icon fas fa-graduation-cap" />
                                        <p className="admin-menu-p">Admission page</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Admission Overview */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-overview/siliguri"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Overview </p>
                                            </NavLink>
                                        </li>
                                        {/* Admission Application Procedur Section section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/admission-application-procedure-section/siliguri"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Admission Procedure</p>
                                            </NavLink>
                                        </li>
                                        {/* Criteria section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/criteria-section/siliguri"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Criteria </p>
                                            </NavLink>
                                        </li>
                                        
                                        {/* School uniform */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/admission-page/school-uniform/siliguri"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">School uniform</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`nav-item ${isLifeAtTIGPSOpen ? "menu-open" : ""}`}>
                                    <a href="#" className={`nav-link ${isLifeAtTIGPSOpen ? "active" : ""}`} onClick={toggleLifeAtTIGPS}>
                                        <i className="nav-icon 	fas fa-school" />
                                        <p className="admin-menu-p">Life at TIGPS</p>
                                        <i className="right fas fa-angle-left" />
                                    </a>
                                    <ul className="nav nav-treeview school-block-border">
                                        {/* Pre primary program section */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/life-at-tigps-section/siliguri"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Beyond Academic</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/gallery/siliguri"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Gallery</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/videos/siliguri"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Videos</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/videos/siliguri"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Videos</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/news-clippings/siliguri"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">News clippings</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/event-list/siliguri"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Event list</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/newsletter/siliguri"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Newsletter</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/techno-echo/siliguri"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Techno Echo</p>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/admin/life-at-tigps-page/prospectus/siliguri"
                                                className={({ isAboutSection }) =>
                                                    `nav-link ${isAboutSection ? "active" : ""}`
                                                }
                                            >
                                                <i className="far fa-hand-point-right nav-icon" />
                                                <p className="admin-menu-p">Prospectus</p>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className="nav-item">
                                    <a href="/admin/general-settings/siliguri" className={`nav-link ${isGeneralSettingsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">General settings</p>
                                    </a>
                                </li> 
                                <li className="nav-item">
                                    <a href="/admin/file-upload/siliguri" className={`nav-link ${isFileUploadsOpen ? "active" : ""}`}>
                                        <i className="fa fa-cog nav-icon" />
                                        <p className="admin-menu-p">File upload</p>
                                    </a>
                                </li> 
                            </ul>
                        </li>    
                    </ul>
                </nav>
            </div>
        </aside>
    );
};

export default AdminMenu;
